import { render, staticRenderFns } from "./embodyDetails.vue?vue&type=template&id=0513cb54&"
import script from "./embodyDetails.vue?vue&type=script&lang=js&"
export * from "./embodyDetails.vue?vue&type=script&lang=js&"
import style0 from "./embodyDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports